{"version":"26.10.20-local-solo","id":"at.softline.abau.portal","name":"Austria Bau Portal"}